import styled from 'styled-components'
import {css} from 'styled-components'

const Style = {
	Container: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 16px;
		padding: 12px;
		background-color: ${({theme}) => theme.color.white || '#FFFFFF'};
		border: 1px solid ${({theme}) => theme.color.grey3 || '#DFDFE7'};
		border-radius: 16px;
	`,

	SectionTitle: styled.h3`
		${({theme}) => theme.font.medium_bold || theme.font.medium};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		font-size: 16px;
		font-weight: 700;
		line-height: 1.2;
		margin: 0;
		align-self: stretch;
	`,

	ContentContainer: styled.div`
		display: flex;
		flex-direction: column;
		gap: 8px;
		width: 100%;
	`,

	NameRow: styled.div`
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 6px;
		width: 100%;
		min-height: 14px;
	`,

	TournamentName: styled.span`
		${({theme}) => theme.font.small_bold || theme.font.small};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		font-size: 12px;
		font-weight: 700;
		line-height: 1.2;
		flex: 1;
	`,

	InfoRow: styled.div.withConfig({
		shouldForwardProp: (prop) => prop !== 'highlight',
	})`
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		${({highlight}) =>
			highlight &&
			css`
				color: ${({theme}) => theme.color.error || '#FF0000'};
			`}
	`,

	Label: styled.p.withConfig({
		shouldForwardProp: (prop) => prop !== 'highlight',
	})`
		${({theme}) => theme.font.extra_small || theme.font.small};
		color: ${({theme}) => theme.color.grey4 || '#8D8D8D'};
		font-size: 12px;
		font-weight: 400;
		line-height: 1.2;
		flex-shrink: 0;
		width: fit-content;
		${({highlight}) =>
			highlight &&
			css`
				color: ${({theme}) => theme.color.error || '#FF0000'};
			`}
	`,

	Value: styled.p.withConfig({
		shouldForwardProp: (prop) => prop !== 'highlight',
	})`
		${({theme}) => theme.font.extra_small || theme.font.small};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		font-size: 12px;
		font-weight: 400;
		line-height: 1.2;
		text-align: right;
		width: fit-content;
		${({highlight}) =>
			highlight &&
			css`
				color: ${({theme}) => theme.color.error || '#FF0000'};
			`}
	`,
}

export default Style
